import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables. Please check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.')
}

// Remove hardcoded HOTEL_SLUG - now managed in BookingContext
export const FALLBACK_HOTEL_ID = 'ad3b9c1c-42fe-4454-a7ed-257b6a445703' // Keep fallback ID for emergencies

export const supabase = createClient(supabaseUrl, supabaseKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  auth: {
    persistSession: false, // Booking engine doesn't need user sessions
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
})

// Updated to accept hotelSlug as parameter instead of using hardcoded value
export const testConnection = async (hotelSlug?: string) => {
  try {
    if (hotelSlug) {
      // Try by name if hotel slug provided
      const { data, error } = await supabase
        .from('hotels')
        .select('id, name')
        .ilike('name', `%${hotelSlug}%`)
        .limit(1)
        .maybeSingle()
      
      if (error) {
        console.error('❌ Erreur de connexion:', error.message)
      } else if (data) {
        console.log('✅ Connected to Supabase! Hotel:', data?.name)
        return true
      }
    }

    // Try fallback direct ID lookup
    const { data: fallbackData, error: fallbackError } = await supabase
      .from('hotels')
      .select('id, name')
      .eq('id', FALLBACK_HOTEL_ID)
      .maybeSingle()
      
    if (fallbackError) {
      console.error('❌ Fallback connection also failed:', fallbackError.message)
      return false
    }
    
    if (!fallbackData) {
      console.error('❌ No fallback hotel found with ID:', FALLBACK_HOTEL_ID)
      return false
    }
    
    console.log('✅ Connected to Supabase using fallback ID! Hotel:', fallbackData?.name)
    return true
  } catch (err) {
    console.error('❌ Unexpected error:', err)
    return false
  }
}